module.exports = __webpack_public_path__ + "img/flat-building.ecf38a3b.png";